import styled from 'styled-components';

export const Container = styled.section`
  width: 100%;
  max-width: 1024px;

  margin-top: 71px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
`;

export const Left = styled.div`
  max-width: 453px;
  flex: 1 1 400px;

  h2 {
    font-size: 56px;
    line-height: 64px;
    font-weight: 700;
  }

  p {
    max-width: 414px;
    margin-top: 16px;
    font-size: 18px;
    line-height: 28px;
  }

  a {
    font-size: 18px;
    line-height: 16px;
    font-weight: 700;
    width: fit-content;

    display: flex;
    align-items: center;
    gap: 10px;

    margin-top: 48px;

    &,
    span {
      color: ${({ theme }) => theme.aplicativos.integracao.button};
      transition: color 0.15s linear;
    }

    :hover {
      &,
      span {
        color: ${({ theme }) => theme.aplicativos.integracao.button}cc;
      }
    }
  }

  span {
    line-height: 16px;
    height: 24px;
  }

  @media (max-width: 850px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: initial;

    h2 {
      max-width: 453px;
      text-align: center;
    }

    p {
      margin-top: 26px;
    }
  }

  @media (max-width: 600px) {
    align-items: flex-start;

    h2 {
      text-align: start;
      font-size: 32px;
      line-height: 40px;
      max-width: 263px;
    }
  }

  @media (max-width: 400px) {
    a {
      font-size: 16px;
    }

    span {
      height: 20px;
    }
  }

  @media (max-width: 365px) {
    a {
      font-size: 14px;
    }
  }

  @media (max-width: 330px) {
    a {
      font-size: 13px;
    }
  }
`;

export const ImageContainer = styled.div`
  &.mobile {
    display: none;
  }

  @media (max-width: 910px) {
    flex: 1 1 300px;
  }

  @media (max-width: 850px) {
    &.desktop {
      display: none;
    }

    &.mobile {
      display: block;

      margin-top: 50px;
    }
  }
`;
